import React from 'react';
import NavSection from './NavSection';
import { sponsorMenuItems } from './menuItems';

const SponsorNav = ({ isOpen, expandedSections, onToggleSection, onNavClick }) => {
    return (
        <>
            <NavSection
                isOpen={isOpen}
                sectionKey="dashboards"
                sectionLabel="Dashboards"
                sectionSubtext="Overview & analytics"
                menuItems={sponsorMenuItems.dashboard}
                isExpanded={expandedSections.dashboards}
                onToggle={onToggleSection}
                onNavClick={onNavClick}
            />

            <NavSection
                isOpen={isOpen}
                sectionKey="sponsor"
                sectionLabel="Sponsor Management"
                sectionSubtext="Consent & data capture"
                menuItems={sponsorMenuItems.management}
                isExpanded={expandedSections.sponsor}
                onToggle={onToggleSection}
                onNavClick={onNavClick}
            />

            <NavSection
                isOpen={isOpen}
                sectionKey="reports"
                sectionLabel="Reports"
                sectionSubtext="Analytics & insights"
                menuItems={sponsorMenuItems.reports}
                isExpanded={expandedSections.reports}
                onToggle={onToggleSection}
                onNavClick={onNavClick}
            />
        </>
    );
};

export default SponsorNav;